module.exports = "/static/assets/4823748f50030407329768f2674e49a9.gif";